// removed by extract-text-webpack-plugin
module.exports = {"navLinks":"src-components-modules-Header-HeaderNav-NavLink-style----general-module---navLinks---KjZ-i fontSize-m fontWeight-5","dark":"src-components-modules-Header-HeaderNav-NavLink-style----general-module---dark---27SqY c-licorice fill-licorice--hover fill-licorice","light":"src-components-modules-Header-HeaderNav-NavLink-style----general-module---light---1jxyf c-white fill-white--hover fill-white"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Header/HeaderNav/NavLink/style/general.module.css
// module id = 1462
// module chunks = 168707334958949